import { CONTAINER_UPDATE_VERSION, CONTAINER_TOGGLE_MENU, CONTAINER_LOADING, CURRENT_MODULE, MODULE_LIST, CURRENT_CONFIG, RESET } from '../actions/Events';

export default function (state = { loading: false }, action) {
  switch (action.type) {
    case CONTAINER_UPDATE_VERSION:
      return { ...state, currentVersion: action.payload }

    case CONTAINER_TOGGLE_MENU:
      return { ...state, menuCollapsed: !state.menuCollapsed }

    case CONTAINER_LOADING:
      return { ...state, loading: action.payload }

    case MODULE_LIST:
      return { ...state, modules: action.payload }

    case CURRENT_MODULE:
      return { ...state, currentModule: action.payload }

    case CURRENT_CONFIG:
      return { ...state, config: action.payload }

    case RESET:
      return { ...state, currentModule: null }

    default:
      return state
  }
}

